
export enum ValueAddedServiceCode {
  LogisticsService= 'LogisticsService',
  ProvisionalLicensePlate= 'ProvisionalLicensePlate',
  VehicleNationalization= 'VehicleNationalization',
  VehicleRegistration= 'VehicleRegistration',
  PowertrainWarranty= 'PowertrainWarranty',
  FleequidCare= 'FleequidCare',
  MechanicalRepairs= 'MechanicalRepairs',
  BodyworkRepairs= 'BodyworkRepairs',
  Coc= 'Coc',
  Other= 'Other',

}